/**
 * Bottom-left version label (OCP-223) - renders the package.json
 * version baked at build time via Vite `define`. Visible on every
 * route (incl. /login) so the operator can verify which release is
 * actually live in the browser without curling the SPA bundle.
 *
 * Click-to-select for easy copy. Fixed-position, low z-index, never
 * blocks interactive UI.
 */
import { useTranslation } from 'react-i18next';

export function AppVersionBadge() {
  const { t } = useTranslation('banners');
  return (
    <div
      className="pointer-events-auto fixed bottom-2 left-2 z-10 select-text font-mono text-xs text-gray-400"
      title={t('appVersion')}
      data-testid="app-version-badge"
    >
      v{__APP_VERSION__}
    </div>
  );
}
